import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';

import TextArea, { TextAreaProps } from '../TextArea';

type UnformTextAreaProps = TextAreaProps & {
  name: string;
};

const UnformTextArea: React.FC<UnformTextAreaProps> = ({ name, ...rest }) => {
  const textAreaRef = useRef<HTMLInputElement>(null);

  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: textAreaRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return <TextArea ref={textAreaRef} defaultValue={defaultValue} {...rest} />;
};

export default UnformTextArea;
